<template>
  <div class="content-box">
    <div class="content-list">
      <div
        class="content-list-text"
        v-for="(item, index) in policyList"
        :key="index"
        :class="{'content-border-bottom': (index+1) % 5 == 0}"
      >
        <div>
          <img src="./../assets/d5.png" />
          <router-link
            tag="a"
            :to="{path: '/policyInfo', query: { Id: item.Id }}"
            target="_blank"
          >{{ item.Title }}</router-link>
          <!-- <router-link
            tag="a"
            :to="{path: '/policyInfo', query: { Title: item.Title,Summary: item.Summary, Createdate: item.Createdate }}"
            target="_blank"
          >{{ item.Title }}</router-link>-->
        </div>
        <div>{{ item.Createdate | dataFilter}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    policyList: {
      type: Array,
      required: true,
      default: function() {
        return [];
      }
    }
  },
  // methods: {
  //   goPolicyInfo(policy) {
  //     this.$router.push({ path: "policyInfo", query: { policy: policy } });
  //   }
  // },
  filters: {
    dataFilter: function(value) {
      let time = value.substring(value.indexOf("(") + 1, value.length - 2);
      let date = new Date(Number(time));
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      // let hours = date.getHours();
      // let minutes = date.getMinutes();
      // let seconds = date.getSeconds();
      return `${year}年${month < 10 ? "0" + month : month}月${day}日`;
    }
  }
};
</script>

<style lang="scss" scoped>
.content-box {
  width: 100%;
  height: 100%;
  .content-list {
    width: 100%;
    height: auto;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0px 20px;
    .content-list-text {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      // border-bottom: 1px dashed #233223;
      padding: 5px 5px;
      div {
        line-height: 30px;
        color: #233223;
        font-size: 16px;
        img {
          margin-right: 5px;
          margin-bottom: 2px;
        }
        a {
          line-height: 30px;
          color: #233223;
          font-size: 16px;
          text-decoration: none;
          &:active {
            color: #233223;
          }
        }
      }
      div:first-of-type {
        text-align: left;
        cursor: pointer;
        transition: 0.5s;
        &:hover {
          color: #176fbd;
          font-weight: bold;
          letter-spacing: 2px;
          text-decoration: underline;
        }
      }
      div:last-of-type {
        text-align: right;
        min-width: 200px;
      }
    }
    .content-border-bottom {
      border-bottom: 1px dashed #de8485;
    }
  }
}
</style>
